const PREFIX = 'slide-pagination';

export const SPARTAN_SLIDE_PAGINATION_TRACKING = {
  root: PREFIX,
  item: (page: number) => `${PREFIX}-item-${page}`,
} as const;
